// Auto-generated from API index at http://nginx/api/index.jsonld
// Do not edit this file manually

import type {
  GetCollectionPath,
  GetExportFeatureCollectionPath,
  GetFeatureCollectionExtentPath,
  GetFeatureCollectionPath,
  GetAggregatedFeatureCollectionPath,
  GetItemPath,
} from '~~/types'

export const API_RESOURCE_MAP = {
  absDatingAnalysis: '/api/data/analyses/absolute_dating',
  absDatingAnalysisBotanyCharcoal:
    '/api/data/analyses/absolute_dating/botany/charcoals',
  absDatingAnalysisBotanySeed:
    '/api/data/analyses/absolute_dating/botany/seeds',
  absDatingAnalysisIndividual: '/api/data/analyses/absolute_dating/individuals',
  absDatingAnalysisPottery: '/api/data/analyses/absolute_dating/potteries',
  absDatingAnalysisSample: '/api/data/analyses/absolute_dating/samples',
  absDatingAnalysisSedimentCoreDepth:
    '/api/data/analyses/absolute_dating/sediment_core_depths',
  absDatingAnalysisZooBone: '/api/data/analyses/absolute_dating/zoo/bones',
  absDatingAnalysisZooTooth: '/api/data/analyses/absolute_dating/zoo/teeth',
  analysis: '/api/data/analyses',
  analysisBotanyCharcoal: '/api/data/analyses/botany/charcoals',
  analysisBotanySeed: '/api/data/analyses/botany/seeds',
  analysisContextBotany: '/api/data/analyses/contexts/botany',
  analysisContextBotanyTaxonomy: '/api/data/analyses/context_botany_taxonomies',
  analysisContextZoo: '/api/data/analyses/contexts/zoo',
  analysisContextZooTaxonomy: '/api/data/analysis_context_zoo_taxonomies',
  analysisIndividual: '/api/data/analyses/individuals',
  analysisPottery: '/api/data/analyses/potteries',
  analysisSample: '/api/data/analyses/samples',
  analysisSampleBotany: '/api/data/analyses/samples/botany',
  analysisSampleBotanyTaxonomy: '/api/data/analyses/sample_botany_taxonomies',
  analysisSampleMicrostratigraphy:
    '/api/data/analyses/samples/microstratigraphy',
  analysisSedimentCoreDepth: '/api/data/analyses/sediment_core_depths',
  analysisSedimentCoreDepthBotany:
    '/api/data/analyses/sediment_core_depths/botany',
  analysisSedimentCoreDepthBotanyTaxonomy:
    '/api/data/analyses/sediment_core_depth_botany_taxonomies',
  analysisSiteAnthropology:
    '/api/data/analyses/archaeological_sites/anthropology',
  analysisSubject: '/api/data/analysis_subjects',
  analysisZooBone: '/api/data/analyses/zoo/bones',
  analysisZooTooth: '/api/data/analyses/zoo/teeth',
  archaeologicalSite: '/api/data/archaeological_sites',
  botanyCharcoal: '/api/data/botany/charcoals',
  botanySeed: '/api/data/botany/seeds',
  context: '/api/data/contexts',
  contextStratigraphicUnit: '/api/data/context_stratigraphic_units',
  historyAnimal: '/api/data/history/animals',
  historyPlant: '/api/data/history/plants',
  historyWrittenSource: '/api/data/history/written_sources',
  historyWrittenSourceCitedWork:
    '/api/data/history/written_sources_cited_works',
  individual: '/api/data/individuals',
  listAnalysisLaboratory: '/api/list/analyses/laboratories',
  listArea: '/api/list/areas',
  listBuildings: '/api/list/buildings',
  listCalibrationCurve: '/api/list/calibration_curves',
  listContextType: '/api/list/contexts/types',
  listHistoryAnimal: '/api/list/history/animals',
  listHistoryPlant: '/api/list/history/plants',
  listHistoryReference: '/api/list/history/references',
  listPerson: '/api/list/persons',
  listPotteryColor: '/api/list/pottery_colors',
  listVocZooTaxonomyClass: '/api/list/vocabulary/zoo/taxonomy_classes',
  listVocZooTaxonomyFamily: '/api/list/vocabulary/zoo/taxonomy_families',
  mediaObject: '/api/data/media_objects',
  mediaObjectAnalysis: '/api/data/media_object_analyses',
  mediaObjectHistoryLocation: '/api/data/media_object_history_locations',
  mediaObjectPaleoclimateSample: '/api/data/media_object_paleoclimate_samples',
  mediaObjectPaleoclimateSamplingSite:
    '/api/data/media_object_paleoclimate_sampling_sites',
  mediaObjectPottery: '/api/data/media_object_potteries',
  mediaObjectSamplingStratigraphicUnit:
    '/api/data/media_object_sampling_stratigraphic_units',
  mediaObjectSedimentCore: '/api/data/media_object_sediment_cores',
  mediaObjectStratigraphicUnit: '/api/data/media_object_stratigraphic_units',
  microstratigraphicUnit: '/api/data/microstratigraphic_units',
  paleoclimateSample: '/api/data/paleoclimate_samples',
  paleoclimateSamplingSite: '/api/data/paleoclimate_sampling_sites',
  pottery: '/api/data/potteries',
  potteryDecoration: '/api/data/pottery_decorations',
  sample: '/api/data/samples',
  sampleStratigraphicUnit: '/api/data/sample_stratigraphic_units',
  samplingSite: '/api/data/sampling_sites',
  samplingStratigraphicUnit: '/api/data/sampling_stratigraphic_units',
  sedimentCore: '/api/data/sediment_cores',
  sedimentCoreDepth: '/api/data/sediment_core_depths',
  siteCulturalContext: '/api/data/site_cultural_contexts',
  siteUserPrivilege: '/api/admin/site_user_privileges',
  stratigraphicUnit: '/api/data/stratigraphic_units',
  stratigraphicUnitRelationship: '/api/data/stratigraphic_unit_relationships',
  user: '/api/admin/users',
  vocAnalysisType: '/api/vocabulary/analysis/types',
  vocBotanyElement: '/api/vocabulary/botany/elements',
  vocBotanyElementPart: '/api/vocabulary/botany/element_parts',
  vocBotanyTaxonomy: '/api/vocabulary/botany/taxonomies',
  vocCentury: '/api/vocabulary/centuries',
  vocCulturalContext: '/api/vocabulary/cultural_contexts',
  vocHistoryAuthor: '/api/vocabulary/history/authors',
  vocHistoryHistoryCitedWork: '/api/vocabulary/history/cited_works',
  vocHistoryLanguage: '/api/vocabulary/history/languages',
  vocHistoryLocation: '/api/vocabulary/history/locations',
  vocHistoryWrittenSourceType: '/api/vocabulary/history/written_source_types',
  vocIndividualAge: '/api/vocabulary/individual/age',
  vocIndividualSex: '/api/vocabulary/individual/sex',
  vocMediaObjectType: '/api/vocabulary/media_object/types',
  vocPotteryDecoration: '/api/vocabulary/pottery/decorations',
  vocPotteryFunctionalForm: '/api/vocabulary/pottery/functional_forms',
  vocPotteryFunctionalGroup: '/api/vocabulary/pottery/functional_groups',
  vocPotteryShape: '/api/vocabulary/pottery/shapes',
  vocPotterySurfaceTreatment: '/api/vocabulary/pottery/surface_treatments',
  vocRegions: '/api/vocabulary/regions',
  vocSampleType: '/api/vocabulary/sample/types',
  vocStratigraphicUnitRelation:
    '/api/vocabulary/stratigraphic_unit/relationships',
  vocZooBone: '/api/vocabulary/zoo/bones',
  vocZooBoneEndPreserved: '/api/vocabulary/zoo/bone_end_preserved',
  vocZooBonePart: '/api/vocabulary/zoo/bone_parts',
  vocZooBoneSide: '/api/vocabulary/zoo/bone-side',
  vocZooTaxonomy: '/api/vocabulary/zoo/taxonomies',
  writtenSourceCentury: '/api/data/written_source_centuries',
  writtenSourceRegion: '/api/data/written_source_regions',
  zooBone: '/api/data/zoo/bones',
  zooTooth: '/api/data/zoo/teeth',
} as const

export type ApiResourceKey = keyof typeof API_RESOURCE_MAP

export type ApiResourcePath =
  (typeof API_RESOURCE_MAP)[keyof typeof API_RESOURCE_MAP]

// Map of each API resource collection path to its corresponding GET item path
// (`${collection}/{id}`). Useful to derive a typed item path from a
// collection path without resorting to string template casts.
export const API_ITEMS_RESOURCE_MAP = {
  '/api/admin/site_user_privileges': '/api/admin/site_user_privileges/{id}',
  '/api/admin/users': '/api/admin/users/{id}',
  '/api/data/analyses': '/api/data/analyses/{id}',
  '/api/data/analyses/absolute_dating':
    '/api/data/analyses/absolute_dating/{id}',
  '/api/data/analyses/absolute_dating/botany/charcoals':
    '/api/data/analyses/absolute_dating/botany/charcoals/{id}',
  '/api/data/analyses/absolute_dating/botany/seeds':
    '/api/data/analyses/absolute_dating/botany/seeds/{id}',
  '/api/data/analyses/absolute_dating/individuals':
    '/api/data/analyses/absolute_dating/individuals/{id}',
  '/api/data/analyses/absolute_dating/potteries':
    '/api/data/analyses/absolute_dating/potteries/{id}',
  '/api/data/analyses/absolute_dating/samples':
    '/api/data/analyses/absolute_dating/samples/{id}',
  '/api/data/analyses/absolute_dating/sediment_core_depths':
    '/api/data/analyses/absolute_dating/sediment_core_depths/{id}',
  '/api/data/analyses/absolute_dating/zoo/bones':
    '/api/data/analyses/absolute_dating/zoo/bones/{id}',
  '/api/data/analyses/absolute_dating/zoo/teeth':
    '/api/data/analyses/absolute_dating/zoo/teeth/{id}',
  '/api/data/analyses/archaeological_sites/anthropology':
    '/api/data/analyses/archaeological_sites/anthropology/{id}',
  '/api/data/analyses/botany/charcoals':
    '/api/data/analyses/botany/charcoals/{id}',
  '/api/data/analyses/botany/seeds': '/api/data/analyses/botany/seeds/{id}',
  '/api/data/analyses/context_botany_taxonomies':
    '/api/data/analyses/context_botany_taxonomies/{id}',
  '/api/data/analyses/contexts/botany':
    '/api/data/analyses/contexts/botany/{id}',
  '/api/data/analyses/contexts/zoo': '/api/data/analyses/contexts/zoo/{id}',
  '/api/data/analyses/individuals': '/api/data/analyses/individuals/{id}',
  '/api/data/analyses/potteries': '/api/data/analyses/potteries/{id}',
  '/api/data/analyses/sample_botany_taxonomies':
    '/api/data/analyses/sample_botany_taxonomies/{id}',
  '/api/data/analyses/samples': '/api/data/analyses/samples/{id}',
  '/api/data/analyses/samples/botany': '/api/data/analyses/samples/botany/{id}',
  '/api/data/analyses/samples/microstratigraphy':
    '/api/data/analyses/samples/microstratigraphy/{id}',
  '/api/data/analyses/sediment_core_depth_botany_taxonomies':
    '/api/data/analyses/sediment_core_depth_botany_taxonomies/{id}',
  '/api/data/analyses/sediment_core_depths':
    '/api/data/analyses/sediment_core_depths/{id}',
  '/api/data/analyses/sediment_core_depths/botany':
    '/api/data/analyses/sediment_core_depths/botany/{id}',
  '/api/data/analyses/zoo/bones': '/api/data/analyses/zoo/bones/{id}',
  '/api/data/analyses/zoo/teeth': '/api/data/analyses/zoo/teeth/{id}',
  '/api/data/analysis_context_zoo_taxonomies':
    '/api/data/analysis_context_zoo_taxonomies/{id}',
  '/api/data/analysis_subjects': '/api/data/analysis_subjects/{id}',
  '/api/data/archaeological_sites': '/api/data/archaeological_sites/{id}',
  '/api/data/botany/charcoals': '/api/data/botany/charcoals/{id}',
  '/api/data/botany/seeds': '/api/data/botany/seeds/{id}',
  '/api/data/context_stratigraphic_units':
    '/api/data/context_stratigraphic_units/{id}',
  '/api/data/contexts': '/api/data/contexts/{id}',
  '/api/data/history/animals': '/api/data/history/animals/{id}',
  '/api/data/history/plants': '/api/data/history/plants/{id}',
  '/api/data/history/written_sources': '/api/data/history/written_sources/{id}',
  '/api/data/history/written_sources_cited_works':
    '/api/data/history/written_sources_cited_works/{id}',
  '/api/data/individuals': '/api/data/individuals/{id}',
  '/api/data/media_object_analyses': '/api/data/media_object_analyses/{id}',
  '/api/data/media_object_history_locations':
    '/api/data/media_object_history_locations/{id}',
  '/api/data/media_object_paleoclimate_samples':
    '/api/data/media_object_paleoclimate_samples/{id}',
  '/api/data/media_object_paleoclimate_sampling_sites':
    '/api/data/media_object_paleoclimate_sampling_sites/{id}',
  '/api/data/media_object_potteries': '/api/data/media_object_potteries/{id}',
  '/api/data/media_object_sampling_stratigraphic_units':
    '/api/data/media_object_sampling_stratigraphic_units/{id}',
  '/api/data/media_object_sediment_cores':
    '/api/data/media_object_sediment_cores/{id}',
  '/api/data/media_object_stratigraphic_units':
    '/api/data/media_object_stratigraphic_units/{id}',
  '/api/data/media_objects': '/api/data/media_objects/{id}',
  '/api/data/microstratigraphic_units':
    '/api/data/microstratigraphic_units/{id}',
  '/api/data/paleoclimate_samples': '/api/data/paleoclimate_samples/{id}',
  '/api/data/paleoclimate_sampling_sites':
    '/api/data/paleoclimate_sampling_sites/{id}',
  '/api/data/potteries': '/api/data/potteries/{id}',
  '/api/data/pottery_decorations': '/api/data/pottery_decorations/{id}',
  '/api/data/sample_stratigraphic_units':
    '/api/data/sample_stratigraphic_units/{id}',
  '/api/data/samples': '/api/data/samples/{id}',
  '/api/data/sampling_sites': '/api/data/sampling_sites/{id}',
  '/api/data/sampling_stratigraphic_units':
    '/api/data/sampling_stratigraphic_units/{id}',
  '/api/data/sediment_core_depths': '/api/data/sediment_core_depths/{id}',
  '/api/data/sediment_cores': '/api/data/sediment_cores/{id}',
  '/api/data/site_cultural_contexts': '/api/data/site_cultural_contexts/{id}',
  '/api/data/stratigraphic_unit_relationships':
    '/api/data/stratigraphic_unit_relationships/{id}',
  '/api/data/stratigraphic_units': '/api/data/stratigraphic_units/{id}',
  '/api/data/written_source_centuries':
    '/api/data/written_source_centuries/{id}',
  '/api/data/written_source_regions': '/api/data/written_source_regions/{id}',
  '/api/data/zoo/bones': '/api/data/zoo/bones/{id}',
  '/api/data/zoo/teeth': '/api/data/zoo/teeth/{id}',
  '/api/list/analyses/laboratories': '/api/list/analyses/laboratories/{id}',
  '/api/list/areas': '/api/list/areas/{id}',
  '/api/list/buildings': '/api/list/buildings/{id}',
  '/api/list/calibration_curves': '/api/list/calibration_curves/{id}',
  '/api/list/contexts/types': '/api/list/contexts/types/{id}',
  '/api/list/history/animals': '/api/list/history/animals/{id}',
  '/api/list/history/plants': '/api/list/history/plants/{id}',
  '/api/list/history/references': '/api/list/history/references/{id}',
  '/api/list/persons': '/api/list/persons/{id}',
  '/api/list/pottery_colors': '/api/list/pottery_colors/{id}',
  '/api/list/vocabulary/zoo/taxonomy_classes':
    '/api/list/vocabulary/zoo/taxonomy_classes/{id}',
  '/api/list/vocabulary/zoo/taxonomy_families':
    '/api/list/vocabulary/zoo/taxonomy_families/{id}',
  '/api/vocabulary/analysis/types': '/api/vocabulary/analysis/types/{id}',
  '/api/vocabulary/botany/element_parts':
    '/api/vocabulary/botany/element_parts/{id}',
  '/api/vocabulary/botany/elements': '/api/vocabulary/botany/elements/{id}',
  '/api/vocabulary/botany/taxonomies': '/api/vocabulary/botany/taxonomies/{id}',
  '/api/vocabulary/centuries': '/api/vocabulary/centuries/{id}',
  '/api/vocabulary/cultural_contexts': '/api/vocabulary/cultural_contexts/{id}',
  '/api/vocabulary/history/authors': '/api/vocabulary/history/authors/{id}',
  '/api/vocabulary/history/cited_works':
    '/api/vocabulary/history/cited_works/{id}',
  '/api/vocabulary/history/languages': '/api/vocabulary/history/languages/{id}',
  '/api/vocabulary/history/locations': '/api/vocabulary/history/locations/{id}',
  '/api/vocabulary/history/written_source_types':
    '/api/vocabulary/history/written_source_types/{id}',
  '/api/vocabulary/individual/age': '/api/vocabulary/individual/age/{id}',
  '/api/vocabulary/individual/sex': '/api/vocabulary/individual/sex/{id}',
  '/api/vocabulary/media_object/types':
    '/api/vocabulary/media_object/types/{id}',
  '/api/vocabulary/pottery/decorations':
    '/api/vocabulary/pottery/decorations/{id}',
  '/api/vocabulary/pottery/functional_forms':
    '/api/vocabulary/pottery/functional_forms/{id}',
  '/api/vocabulary/pottery/functional_groups':
    '/api/vocabulary/pottery/functional_groups/{id}',
  '/api/vocabulary/pottery/shapes': '/api/vocabulary/pottery/shapes/{id}',
  '/api/vocabulary/pottery/surface_treatments':
    '/api/vocabulary/pottery/surface_treatments/{id}',
  '/api/vocabulary/regions': '/api/vocabulary/regions/{id}',
  '/api/vocabulary/sample/types': '/api/vocabulary/sample/types/{id}',
  '/api/vocabulary/stratigraphic_unit/relationships':
    '/api/vocabulary/stratigraphic_unit/relationships/{id}',
  '/api/vocabulary/zoo/bone_end_preserved':
    '/api/vocabulary/zoo/bone_end_preserved/{id}',
  '/api/vocabulary/zoo/bone_parts': '/api/vocabulary/zoo/bone_parts/{id}',
  '/api/vocabulary/zoo/bone-side': '/api/vocabulary/zoo/bone-side/{id}',
  '/api/vocabulary/zoo/bones': '/api/vocabulary/zoo/bones/{id}',
  '/api/vocabulary/zoo/taxonomies': '/api/vocabulary/zoo/taxonomies/{id}',
} as const satisfies Record<ApiResourcePath, GetItemPath>

export type ApiItemPath =
  (typeof API_ITEMS_RESOURCE_MAP)[keyof typeof API_ITEMS_RESOURCE_MAP]

// Map of feature collection endpoints (GeoJSON) to their related API resource collection path
// Keys are OpenAPI paths that return 200 with 'application/geo+json'
export const API_FEATURES_RESOURCE_MAP = {
  '/api/features/archaeological_sites': '/api/data/archaeological_sites',
  '/api/features/botany/charcoals': '/api/data/botany/charcoals',
  '/api/features/botany/seeds': '/api/data/botany/seeds',
  '/api/features/history/animals': '/api/data/history/animals',
  '/api/features/history/locations': '/api/vocabulary/history/locations',
  '/api/features/history/plants': '/api/data/history/plants',
  '/api/features/individuals': '/api/data/individuals',
  '/api/features/microstratigraphic_units':
    '/api/data/microstratigraphic_units',
  '/api/features/paleoclimate_samples': '/api/data/paleoclimate_samples',
  '/api/features/paleoclimate_sampling_sites':
    '/api/data/paleoclimate_sampling_sites',
  '/api/features/potteries': '/api/data/potteries',
  '/api/features/sampling_sites': '/api/data/sampling_sites',
  '/api/features/sampling_stratigraphic_units':
    '/api/data/sampling_stratigraphic_units',
  '/api/features/sediment_core_depths': '/api/data/sediment_core_depths',
  '/api/features/sediment_cores': '/api/data/sediment_cores',
  '/api/features/stratigraphic_units': '/api/data/stratigraphic_units',
  '/api/features/zoo/bones': '/api/data/zoo/bones',
  '/api/features/zoo/teeth': '/api/data/zoo/teeth',
} as const satisfies Record<GetFeatureCollectionPath, GetCollectionPath>

export const API_FEATURES_RESOURCE_EXPORT_MAP = {
  '/api/features/archaeological_sites':
    '/api/features/export/archaeological_sites',
  '/api/features/botany/charcoals': '/api/features/export/botany/charcoals',
  '/api/features/botany/seeds': '/api/features/export/botany/seeds',
  '/api/features/history/animals': '/api/features/export/history/animals',
  '/api/features/history/locations': '/api/features/export/history/locations',
  '/api/features/history/plants': '/api/features/export/history/plants',
  '/api/features/individuals': '/api/features/export/individuals',
  '/api/features/microstratigraphic_units':
    '/api/features/export/microstratigraphic_units',
  '/api/features/paleoclimate_samples':
    '/api/features/export/paleoclimate_samples',
  '/api/features/paleoclimate_sampling_sites':
    '/api/features/export/paleoclimate_sampling_sites',
  '/api/features/potteries': '/api/features/export/potteries',
  '/api/features/sampling_sites': '/api/features/export/sampling_sites',
  '/api/features/sampling_stratigraphic_units':
    '/api/features/export/sampling_stratigraphic_units',
  '/api/features/sediment_core_depths':
    '/api/features/export/sediment_core_depths',
  '/api/features/sediment_cores': '/api/features/export/sediment_cores',
  '/api/features/stratigraphic_units':
    '/api/features/export/stratigraphic_units',
  '/api/features/zoo/bones': '/api/features/export/zoo/bones',
  '/api/features/zoo/teeth': '/api/features/export/zoo/teeth',
} as const satisfies Record<
  GetFeatureCollectionPath,
  GetExportFeatureCollectionPath
>

export const API_FEATURES_EXTENT_RESOURCE_MAP = {
  '/api/features/archaeological_sites':
    '/api/features/extent_matched/archaeological_sites',
  '/api/features/botany/charcoals':
    '/api/features/extent_matched/botany/charcoals',
  '/api/features/botany/seeds': '/api/features/extent_matched/botany/seeds',
  '/api/features/history/animals':
    '/api/features/extent_matched/history/animals',
  '/api/features/history/locations':
    '/api/features/extent_matched/history/locations',
  '/api/features/history/plants': '/api/features/extent_matched/history/plants',
  '/api/features/individuals': '/api/features/extent_matched/individuals',
  '/api/features/microstratigraphic_units':
    '/api/features/extent_matched/microstratigraphic_units',
  '/api/features/paleoclimate_samples':
    '/api/features/extent_matched/paleoclimate_samples',
  '/api/features/paleoclimate_sampling_sites':
    '/api/features/extent_matched/paleoclimate_sampling_sites',
  '/api/features/potteries': '/api/features/extent_matched/potteries',
  '/api/features/sampling_sites': '/api/features/extent_matched/sampling_sites',
  '/api/features/sampling_stratigraphic_units':
    '/api/features/extent_matched/sampling_stratigraphic_units',
  '/api/features/sediment_core_depths':
    '/api/features/extent_matched/sediment_core_depths',
  '/api/features/sediment_cores': '/api/features/extent_matched/sediment_cores',
  '/api/features/stratigraphic_units':
    '/api/features/extent_matched/stratigraphic_units',
  '/api/features/zoo/bones': '/api/features/extent_matched/zoo/bones',
  '/api/features/zoo/teeth': '/api/features/extent_matched/zoo/teeth',
} as const satisfies Record<
  GetFeatureCollectionPath,
  GetFeatureCollectionExtentPath
>

export const API_AGGREGATED_FEATURES_RESOURCE_PATHS: GetAggregatedFeatureCollectionPath[] =
  [
    '/api/features/botany/charcoals',
    '/api/features/botany/seeds',
    '/api/features/history/animals',
    '/api/features/history/plants',
    '/api/features/individuals',
    '/api/features/microstratigraphic_units',
    '/api/features/paleoclimate_samples',
    '/api/features/potteries',
    '/api/features/sampling_stratigraphic_units',
    '/api/features/sediment_cores',
    '/api/features/sediment_core_depths',
    '/api/features/stratigraphic_units',
    '/api/features/zoo/bones',
    '/api/features/zoo/teeth',
  ]

type FeaturesMap = typeof API_FEATURES_RESOURCE_MAP
export type FeaturePathToApiResourcePath<P extends GetFeatureCollectionPath> =
  FeaturesMap[P]

// Type helper: map a GetFeatureCollectionPath to the corresponding GetItemPath
// by appending '/{id}' to the related ApiResourcePath, and intersecting with GetItemPath
export type FeaturePathToItemPath<P extends GetFeatureCollectionPath> = Extract<
  GetItemPath,
  `${FeaturePathToApiResourcePath<P>}/{id}`
>
